export function NotFoundPage() {
  return (
    <div className="paper">
      <h1>PAGE NOT FOUND</h1>
    </div>
  );
}
